<template>
  <div>
    <div class="admin-header">
      <div class="container">
        <div class="row">
        <div class="col-lg-12">
          <h1 class="white">Product List</h1>
        </div>
        </div>
      </div>
    </div>

    <!-- Product Filter -->
    <div style="padding-top:2rem" class="container section-padding">
      <div class="row">
        <div class="col-lg-12">
          <div class="form-group filter-box">
            <h3>Filters</h3>
            <label for="type">Product Type:</label>
            <select class="form-control" id="type" v-model="productType" @change="loadProducts">
              <option value="car">Car</option>
              <option value="electronic">Electronic</option>
              <option value="engine">Engine</option>
              <option value="helicopter">Helicopter</option>
              <option value="kit">Kit</option>
              <option value="plane">Plane</option>
              <option value="spare">Spare</option>
              <option value="steam">Steam</option>
              <option value="tool">Tool</option>
              <option value="train">Train</option>
            </select>
            <label class="space-top-small" for="status">Product Status:</label>
            <select class="form-control" id="status" v-model="productStatus" @change="loadProducts">
              <option value="listed">Listed</option>
              <option value="sold">Sold</option>
            </select>
          </div>
        </div>
        <!-- List of Products -->
        <div class="container" v-if="loadingProducts">
          <div class="row space-loader d-flex align-items-center justify-content-center">
            <b-spinner style="width: 6rem; height: 6rem;" label="Large Spinner"></b-spinner>
          </div>
        </div>
          <ProductCard v-else v-for="(product, productIndex) in products" :key="productIndex" v-bind:product="product" v-on:delete-product="deleteProduct" v-on:edit-product="editProduct" />
       
      </div>
    </div>
  </div>
</template>

<script>
  import ProductCard from "@/components/Admin/ProductCard.vue";
  import api from "../../api/api";

  export default {
    components: {
      ProductCard,
    },
    data: function () {
      return {
        productType: "car",
        productStatus: "listed",
        products: {},
        loadingProducts: false,
      };
    },
    mounted() {
      this.loadProducts();
    },
    methods: {
      editProduct(id) {
        this.$router.push(`/admin/products/${id}/edit`);
      },
      deleteProduct(id) {
        api.deleteProduct(id).then(() => {
          this.$delete(this.products, id);
        }).catch(() => {
          //console.log(err);
        })
      },
      loadProducts() {
        this.loadingProducts = true;
        this.products = {};
        api
          .getProductsByTypeAndStatus(this.productType, this.productStatus)
          .then((res) => {
            for (var i = 0; i < res.products.length; i++) {
              this.$set(this.products, res.products[i].id, res.products[i]);
            }
          })
          // .catch((err) => {
          //   console.log(err);
          // })
          .finally(() => {
            this.loadingProducts = false;
          });
      },
    },
  };
</script>